import React, { useState, useEffect } from 'react';
import { Autocomplete, Checkbox, TextField, ListItemText, FormControl } from '@mui/material';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import { Column } from 'react-table';

interface ColumnSelectorProps {
  /**
   * full list of columns (with their current .show flags)
   */
  columns: Column[];
  /**
   * called with updated columns array whenever user toggles
   */
  onChange: (updated: Column[]) => void;
  /**
   * if true, will stretch to fill parent width
   */
  fullWidth?: boolean;
}

export const ColumnSelector: React.FC<ColumnSelectorProps> = ({ columns, onChange, fullWidth }) => {
  // initialize selected values to those columns where show===true
  const [selected, setSelected] = useState<Column[]>(columns.filter(col => col.show));

  // if parent ever replaces columns prop, resync our selected state
  useEffect(() => {
    setSelected(columns.filter(col => col.show));
  }, [columns]);

  const handleChange = (_evt: React.SyntheticEvent, value: Column[]) => {
    setSelected(value);
    // map through all columns and flip show based on presence in value[]
    const updated = columns.map(col => ({
      ...col,
      show: !!value.find(sel => sel.accessor === col.accessor),
    }));
    onChange(updated);
  };

  return (
    <FormControl variant="filled">
      <Autocomplete
        multiple
        size="small"
        options={columns}
        getOptionLabel={(option: any) => option.Header}
        value={selected}
        onChange={handleChange}
        renderInput={params => <TextField {...params} variant="outlined" label="Columns" />}
      />
    </FormControl>
  );
};
